import React from 'react';

const FormContext = React.createContext();
const FormContextConsumer = FormContext.Consumer;
const FormContextProvider = FormContext.Provider;
export {FormContext, FormContextConsumer, FormContextProvider};